import { Component, OnInit } from '@angular/core';
import { CMSContentService } from '../../essentials/cms/content/cms-content.service';

@Component({
  selector: 'fcp-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  public company = [];
  public social = [];
  public links;
  public badges;
  public showChat: boolean;

  constructor(
    private cmsContentService: CMSContentService
  ) { }

  ngOnInit() {
    const params = { $orderby: 'data/Ordem/iv' };
    this.cmsContentService.getFooterLinks().subscribe(response => {
      this.company = response;
    });
    this.cmsContentService
      .return('redes-sociais', params)
      .subscribe(response => {
        this.setSocial(response.items);
      });
    this.cmsContentService.return('rodape').subscribe(response => {
      this.links = response.items[0].data.Links.iv;
      this.badges = response.items[0].data.Selos.iv;
    });

    const urlArray = window.location.href.split('/');
    this.showChat = urlArray[urlArray.length - 1] === 'home';
  }

  setSocial(items: any[]) {
    this.social = items.map(item => {
      if (item.data) {
        return {
          title: item.data.Titulo.iv,
          img: item.data.Icone ? item.data.Icone.iv : null,
          url: item.data.URL ? item.data.URL.iv : null
        };
      }
    });
  }

}
